module.exports = __webpack_public_path__ + "img/bet365.f60e9e0b.jpg";